import { useEffect, useRef, useState } from "react";
import root from "react-shadow";
import { z } from "zod";

import { FundFinder } from "@hsl/lgim-explorer/src/widgets";

export const DataPropsSchema = z.object({
    audience: z.string(),
    jurisdiction: z.string().optional(),
    version: z.string().optional(),
    language: z.string(),
    baseurl: z.string().optional(),
});
export type DataProps = z.infer<typeof DataPropsSchema>;

type Props = {
    dataProps: DataProps;
    stylesheet: string;
};

const CONFIG_ID = 15327;

export default function Widget({ dataProps, stylesheet }: Props) {
    const rootRef = useRef<HTMLDivElement>();
    const [styles, setStyles] = useState<string>("");

    useEffect(() => {
        fetch(stylesheet)
            .then((res) => res.text())
            .then((css) => setStyles(css))
            .catch((err) => console.error(err));
    }, [stylesheet]);

    return (
        <root.div ref={rootRef}>
            <style>{styles}</style>
            <FundFinder {...dataProps} configId={`${CONFIG_ID}`} />
        </root.div>
    );
}
